export function getAllUserSignupItemIDs(userSignupItems) {
  if (!userSignupItems) return [];

  const userSignupItemIDs = [];

  Object.keys(userSignupItems).forEach((itemID) => {
    userSignupItems[itemID].respondents.forEach((respondent) => {
      userSignupItemIDs.push(respondent.userSignupItemID);
    });
  });

  const userSignupItemIDsClean = [...new Set(userSignupItemIDs)].filter(
    Boolean // Do not include undefined from isAdditional folk
  ); // de-dupe the IDs
  return userSignupItemIDsClean;
}
